import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GameObject, Transform2dComponent} from '@specials/gcs-engine';

import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

import {EmitterPoolComponent} from '../../components/EmitterPoolComponent';
import {HeartsEmitterComponent} from '../../components/HeartsEmitterComponent/HeartsEmitterComponent';
import {WaveEmitterComponent} from '../../components/WaveEmitterComponent/WaveEmitterComponent';
import {BackgroundGalaxyStarsComponent} from './components/BackgroundGalaxyStarsComponent';
import {BackgroundGalaxyViewComponent} from './components/BackgroundGalaxyViewComponent';
import {ResultsBackgroundGalaxyDataComponent} from './components/ResultsBackgroundGalaxyDataComponent';
import {ResultsBackgroundGalaxyInteractivityComponent} from './components/ResultsBackgroundGalaxyInteractivityComponent';

export class ResultsBackgroundGalaxy extends GameObject {
  constructor(
    public readonly transformComponent: Transform2dComponent,
    public readonly viewComponent: BackgroundGalaxyViewComponent,
    public readonly galaxyStarComponent: BackgroundGalaxyStarsComponent,
    public readonly interactivityComponent: ResultsBackgroundGalaxyInteractivityComponent,
    private readonly dataComponent: ResultsBackgroundGalaxyDataComponent,
    private readonly emitterPoolComponent: EmitterPoolComponent,
    private readonly heartsEmitterComponent: HeartsEmitterComponent,
    private readonly waveEmitterComponent: WaveEmitterComponent,
    private readonly rendererComponent: PixiViewRendererComponent,
  ) {
    super();

    this.addComponent(
      this.dataComponent,
      this.transformComponent,
      this.viewComponent,
      this.galaxyStarComponent,
      this.emitterPoolComponent,
      this.heartsEmitterComponent,
      this.waveEmitterComponent,
      this.interactivityComponent,
      this.rendererComponent,
    );
  }
}

injected(
  ResultsBackgroundGalaxy,
  DI_TOKENS.transform2dComponent,
  DI_TOKENS.clickerGameBackgroundGalaxyViewComponent,
  DI_TOKENS.clickerGameBackgroundGalaxyStarsComponent,
  DI_TOKENS.clickerGameResultsBackgroundInteractivityComponent,
  DI_TOKENS.clickerGameResultsBackgroundGalaxyDataComponent,
  DI_TOKENS.clickerGameEmitterPoolComponent,
  DI_TOKENS.clickerGameHeartsEmitterComponent,
  DI_TOKENS.clickerGameWaveEmitterComponent,
  DI_TOKENS.pixiViewRendererComponent,
);
